<template>
    <div class="container-fluid">
        <div class="row">      
            <Navbar :class="[mobile?'navbar-admin':'navbar-admin-mobile']" v-show="toggle"></Navbar>
            <div  :class="{ 'col-lg-12': !toggle }"  class="col-lg-9 col-md-12 col-xs-12">
              <div class="container">

                <Controls></Controls>
          
                <!--
                <Controls2></Controls2>
                -->

                
                  <!--seccion pasos-->
                  <div class="row">
                      <div class="col-12">
                        <button class="btn btn-default btn-custom-fixed" @click='toggle = !toggle'> 
                          <font-awesome-icon v-show="toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-left']" /> 
                          <font-awesome-icon v-show="!toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-right']" /> 
                        </button>

                       <button class="d-xl-none btn btn-default btn-custom-fixed-mobile" @click='mobile = !mobile'> 
                          <font-awesome-icon style="z-index:2;"  :style="{ color: '#FFFFFF', position: 'absolute', left: '3', top: '2' }" size="2x" :icon="['fas', 'bars']" /> 
                        </button>

                        <div class="container mt-2">
                            <div class="row">
                            <div class="col-md-12 col-sm-12">
                                    <center>
                                    <h1 v-if="iso639_1 === 'es'">Editar Perfil</h1>
                                    <h1 v-else>Edit profile</h1>
                                    </center>
                          
                                    <div class="form-group">
                                        <label v-if="iso639_1 === 'es'" class="title-form">Nombre</label> 
                                        <label v-else class="title-form">Name</label> 
                                        <input  v-model="perfil.nombre" type="text" class="form-control  btn-sombra" placeholder="Jon doe">
                                    </div>

                                    <div class="form-group">
                                        <label v-if="iso639_1 === 'es'" class="title-form">Apellido</label>
                                        <label v-else class="title-form">Surname</label> 
                                        <input  v-model="perfil.apellido" type="text" class="form-control  btn-sombra" placeholder="Jon doe">
                                    </div>

                                    <div class="form-group">
                                        <label v-if="iso639_1 === 'es'" class="title-form">Teléfono</label>
                                        <label v-else class="title-form">Phone</label>
                                        <input v-model="perfil.telefono"  type="text" class="form-control btn-sombra" placeholder="+569929294954">
                                    </div>

                                    <div class="form-group">
                                        <label v-if="iso639_1 === 'es'" class="title-form">Fecha de Nacimiento (DD/MM/AAAA)</label>
                                        <label v-else class="title-form">Date of birth (DD/MM/AAAA)</label>
                                        <div class="row">
                                            <div class="col-4">
                                                <input v-model="perfil.fnacimiento.dia" placeholder="1"  min="1" max="31" type="number" class="form-control btn-sombra">     
                                            </div>
                                            <div class="col-4">
                                                <input v-model="perfil.fnacimiento.mes" placeholder="1"  min="1" max="12" type="number" class="form-control btn-sombra">                                   
                                            </div>  
                                            <div class="col-4">
                                                <input v-model="perfil.fnacimiento.ano" placeholder="1990" min="1950" max="" type="number" class="form-control btn-sombra">
                                            </div>                          
                                        </div>                  
                                    </div>        
                                    

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-6">
                                                <label v-if="iso639_1 === 'es'" class="title-form">Nacionalidad</label>
                                                <label v-else class="title-form">Nationality</label>
                                                <div class="content-select">
                                                    <select v-model="perfil.pais_idpais">
                                                        <option value="" disabled selected >Seleccione</option>
                                                        <option :selected="user.pais_idpais === pais.idpais" v-bind:value="pais.idpais" :key="pais.idpais" v-for="pais in paises" class="black">
                                                            {{ pais.nombre }}
                                                        </option>
                                                    </select>
                                                    <i></i>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <label v-if="iso639_1 === 'es'" class="title-form">Sexo</label>
                                                <label v-else class="title-form">Sex</label>
                                                <div class="content-select">
                                                    <select v-model="perfil.sexo">
                                                        <option value="" disabled selected >Seleccione</option>
                                                        <option :selected="perfil.sexo === 'm'" class="black">Masculino</option>
                                                        <option :selected="perfil.sexo === 'f'" class="black">Femenino</option>
                                                    </select>
                                                    <i></i>
                                                </div>
                                            </div>                          
                                        </div>                  
                                    </div>                                
                  
                                    <div class="form-group mt-4">
                                        <label v-if="iso639_1 === 'es'" class="title-form">Biografía</label>
                                        <label v-else class="title-form">Biography</label>
                                        <textarea v-model="perfil.biografia" name="message" placeholder="Cuéntanos sobre ti…" class="form-control" rows="10" cols="30"></textarea>
                                    </div>
                                    
                                    <button v-if="iso639_1 === 'es'" @click="actualizarPerfil(perfil)" class="form-control" type="submit">Guardar</button>
                                    <button v-else @click="actualizarPerfil(perfil)" class="form-control" type="submit">Save</button>
 
                                </div>
                               
                            </div>
                          <hr>
                        </div>
                        <div class="spacing"></div>   

                  <b-modal ref="my-modal" hide-footer title="Using Component Methods">
                    <div class="d-block text-center">
                      <h3>Hello From My Modal!</h3>
                    </div>
                  </b-modal>

                      </div>
                  </div>
                  <!--fin seccion inputs-->
              </div>
            </div>
        </div>    
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import router from '@/router'
import Navbar from '@/components/Navbar.vue'
import Controls from '@/components/Controls.vue'
import axios from 'axios'

export default {
  name: 'EditarPerfil', 
  components: {
    Navbar,
    Controls
  },
  data() {
    return {
     toggle: true,
     mobile : true,
     paises: [],
     perfil: {
      idusuario: this.$store.state.user.idusuario,
      nombre: this.$store.state.user.nombre,
      apellido: this.$store.state.user.apellido,
      telefono: this.$store.state.user.telefono,
      fnacimiento: {
          dia: this.$store.state.user.dia,
          mes: this.$store.state.user.mes,
          ano: this.$store.state.user.ano
      },
      pais_idpais: this.$store.state.user.pais_idpais,
      sexo: this.$store.state.user.sexo,
      biografia: this.$store.state.user.biografia
     }
    }
  },
  methods:{
    ...mapActions(['actualizarPerfil'])
  },
  computed:{
    ...mapState(['user', 'language', 'iso639_1'])
  },   
  created () {
    let currentObj = this;
    axios
      .get(process.env.VUE_APP_API_URL+'countries')
      .then(response => (currentObj.paises = response.data))
  }
}
</script>




<style scoped>
.dot {
  height: 25px;
  width: 25px;
   background-color: #F7F7F7;
  border-radius: 50%;
  display: inline-block;
  border: 1px;
  color: #5A287F;
  border-style: solid;
  border-width: 1px;
  border-color:#5A287F;
}
.btn-custom-fixed{
   background-color:#5A287F;
   color:white;
   width: 35px; 
   height: 60px;
   position: absolute;
   left: -50px;
   top: 60px;
}

@media (max-width: 991px) {
  .btn-custom-fixed{
   display: none;
  }
}

.opt-active{
  background-color: #5A287F;
  color: #FFFFFF;
  border-radius: 0;
}

.total{
  background-color: #5A287F;
  position: absolute;
  top:150px;
  width: auto;
}

.card-footer{
    background-color: #5A287F;
    color:white;
}

.recibe{
    background-color: #5A287F;
    color:white;
}

.circulo {
     width: 20px;
     height: 20px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: #A2C037;
}

.circulo-red {
     width: 20px;
     height: 20px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: #FF5353;
}
</style>


